var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.736l.834.062C1.7 5.818 2.04 2.916 7.14 3.484c-.186 12.43-5.625 13.742-5.285 16.292.124 1.446 1.267 2.334 2.503 2.385 3.905-.134 3.73-5.41 4.945-18.708h5.037c-.267 4.688-.999 9.375-1.081 13.97.062 3.055 1.916 4.687 4.357 4.707 4.018.135 5.285-4.563 5.285-6.566h-.865c-.083 1.652-.876 2.84-2.565 2.911-4.605.062-2.07-8.115-2.04-14.96l5.47.031-.03-3.5C.132-.064 3.02-.511 0 6.736z",
    fill: "#FC6C2E",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath);
export default __webpack_public_path__ + "static/media/math.5c3d602f.svg";
export { ForwardRef as ReactComponent };